import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PortalAdminService } from 'src/app/services/portal-admin.service';
import { HttpClient } from '@angular/common/http';
import { TokenService } from 'src/app/services/getData_token.service';

@Component({
  selector: 'app-ai-instructions',
  templateUrl: './ai-instructions.component.html',
  styleUrls: ['./ai-instructions.component.css'],
})
export class AiInstructionsComponent implements OnInit {
  loading: boolean = false;
  selected: string = 'ai-instructions';
  displayLoader: boolean = true;
  errorMessage: string = '';
  isPortalAdmin!: boolean;
  adminInstructions: string = '';
  userId!: number;
  email: any = '';
  successMessage: string = '';
  showSuccessAlert: boolean = false;

  constructor(
    private portalAdminService: PortalAdminService,
    private http: HttpClient, private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.checkAdminStatus();
    const userDetails = this.tokenService.getUserDetails();
    if (userDetails) {
      this.email = userDetails.email;
    }
  }

  checkAdminStatus() {
    // Set default to false first
    this.isPortalAdmin = true;
    // Then check with service
    this.portalAdminService.isPortalAdmin().subscribe({
      next: (res: any) => {
        this.isPortalAdmin = !!res; // Convert to boolean
        if (this.isPortalAdmin === true) {
          this.getAiInstructions();
        }
      },
      error: (error) => {
        this.isPortalAdmin = false;
      },
    });
  }

  getAiInstructions() {
    const apiUrl = `${environment.apiConfig.uri}/admin/AdminClientContact/getOpenAiInstruction`;
    this.http.get(apiUrl).subscribe({
      next: (response: any) => {
        this.adminInstructions = response.data.instructions;
        this.userId = response.data.id;
        this.displayLoader = false;
      },
      error: (error) => {
        // console.error('Error updating status', error);
      },
    });
  }

  submitInstructions() {
    // Validate that instructions are not empty
    if (!this.adminInstructions || !this.adminInstructions.trim()) {
      this.errorMessage = 'Instructions cannot be empty';
      return;
    }
    this.loading = true;
    this.errorMessage = '';
    const payload = {
      id: this.userId,
      email: this.email,
      instructions: this.adminInstructions.trim(),
    };

    // Store the submitted value
    const submittedInstructions = this.adminInstructions.trim();

    const submitUrl = `${environment.apiConfig.uri}/admin/AdminClientContact/UpdateOpenAiInstruction`;
    this.http.post(submitUrl, payload).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          // Keep the submitted value in the UI
          this.adminInstructions = submittedInstructions;
          
          this.successMessage = 'Instructions updated successfully!';
          this.showSuccessAlert = true;
          
          // Add a delay before refreshing from server to ensure DB update is complete
          setTimeout(() => {
            this.getAiInstructions();
          }, 1000);

          // Hide success message after 3 seconds
          setTimeout(() => {
            this.showSuccessAlert = false;
            this.successMessage = '';
          }, 3000);
        } else {
          this.errorMessage = response.message || 'Failed to update instructions';
        }
        this.loading = false;
      },
      error: (error) => {
        this.errorMessage = 'An error occurred while updating instructions';
        this.loading = false;
      }
    });
  }
}
